/**
 * OAuth 授权守卫模块
 * 封装微信/企业微信 OAuth 回调处理与授权跳转逻辑
 *
 * 开发环境：跳过所有授权校验
 * 生产环境：必须通过微信或企业微信授权
 */
import wxOAuth from '@/utils/wxOAuth.js'
import { wxWorkLogin, wxLogin } from '@/api/login.js'
import { isWxWork, isWeixin } from '@/utils/env.js'

/**
 * 处理 OAuth 回调
 * URL 中携带 code 参数时，根据 state 调用对应的后端登录接口，存储 token
 * @returns {Promise<boolean>} 是否处理了 OAuth 回调
 */
 function handleOAuthCallback() {
  return  new Promise(async (resolve) => {
    console.log('判断url存不存再code',wxOAuth.hasOAuthCallback())
    if (!wxOAuth.hasOAuthCallback()) {
      resolve(false)
      return // 直接终止当前Promise回调函数，不再往下执行
    }
    const { code, state } = wxOAuth.getCodeFromUrl()
    console.log('处理OAuth回调', code, state)
    try {
      const res = state === 'wxwork'
          ? await wxWorkLogin({ code })
          : await wxLogin({ code })
      console.log("登录返回", res)
      if (res) {
        if (state === "wxwork") {
          localStorage.userid = res.userid
        } else if (state === "wechat") {
          localStorage.wjr_token = res.wjr_token
        }
      }
      wxOAuth.clearCodeFromUrl()
    } catch (e) {
      console.error('OAuth 登录失败:', e)
    }

    wxOAuth.clearCodeFromUrl()
    resolve( true)
  })

}

/**
 * 发起企业微信 OAuth 授权跳转
 * @param {String} redirectUri - 授权回调地址
 */
function redirectWxWorkAuth(redirectUri, agentId = "") {
  wxOAuth.redirectToBaseOAuth({
    corpId: import.meta.env.VITE_APP_WXWORK_CORPID,
    redirectUri,
    agentId: agentId,
    state: 'wxwork',
  })
}

/**
 * 发起微信公众号 OAuth 授权跳转
 * @param {String} redirectUri - 授权回调地址
 */
function redirectWechatAuth(redirectUri) {
  wxOAuth.redirectToWechatOAuth({
    appId: import.meta.env.VITE_APP_WECHAT_APPID,
    redirectUri,
    scope: 'snsapi_userinfo',
    state: 'wechat',
  })
}

/**
 * OAuth 授权守卫（供 router.beforeEach 调用）
 *
 * 授权流程：
 *   1. 处理 OAuth 回调（URL 携带 code）
 *   2. 环境校验：根据 meta.isQiwei 限制页面运行环境
 *      - isQiwei: true  → 仅允许企业微信
 *      - isQiwei: false → 仅允许微信
 *   3. 无需授权的路由或已有 token → 直接放行
 *   4. 无 token 时，根据当前环境发起对应授权：
 *      - 企业微信环境 → 企业微信授权
 *      - 微信环境 → 微信公众号授权
 *      - 其他环境 → 拒绝访问
 *
 * 返回值语义：
 *   'next'     — 调用方应执行 next()，页面正常放行
 *   'callback' — 已完成 OAuth 回调处理，调用方应执行 next() 进入页面
 *   'redirect' — 已发起 OAuth 跳转，调用方无需做任何事
 *
 * @param {Object} to - vue-router 目标路由对象
 * @returns {Promise<'next'|'callback'|'redirect'>}
 */
export default async function authGuard(to) {
  console.log('进入路由', to.fullPath)
  console.log('企业微信环境判断isWxWork()', isWxWork())
  // 第一步：处理 OAuth 回调（URL 中携带 code）
  if ( await handleOAuthCallback()) return 'callback'
  // 第二步：环境校验 — isQiwei 为 true 只允许企业微信，false 只允许微信
  if (to.meta.isQiwei === true && !isWxWork()) {
    document.body.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:100vh;font-size:16px;color:#666;">请在企业微信中打开此页面</div>'
    return 'redirect'
  }
  if (to.meta.isQiwei === false && !isWeixin()) {
    document.body.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:100vh;font-size:16px;color:#666;">请在微信中打开此页面</div>'
    return 'redirect'
  }

  // 第三步：无需授权的路由 或 已有 token → 直接放行
  if (to.meta.noAuth) return 'next'
  console.log('企业微信环境',localStorage.getItem('userid'),isWxWork())
  console.log('微信环境',localStorage.getItem('wjr_token'),isWeixin())
  if (localStorage.getItem('userid') && isWxWork()) return 'next'
  if (localStorage.getItem('wjr_token') && isWeixin()) return 'next'

  if (to.query) localStorage.urlState = JSON.stringify(to.query)
console.log("isWxWork()", isWxWork())
  // 第四步：无 token，根据当前环境发起对应授权
  if (isWxWork()) {
    console.log("isWxWork()", '121212')
    // 企业微信环境 → 企业微信授权
    const redirectUri = window.location.origin + to.fullPath
    // const redirectUri = `https://ylp.zjems.com${to.fullPath}`
    console.log("redirectUri", redirectUri)
    redirectWxWorkAuth(redirectUri, to.meta.agentId)
    return 'redirect'
  }

  if (isWeixin()) {
    console.log('微信公众号授权',`https://wechat.zheyouhui.com/qiwei${to.fullPath}`)
    // 微信环境 → 微信公众号授权
    let url = `https://wechat.zheyouhui.com/qiwei${to.fullPath}`
    redirectWechatAuth(url)
    return 'redirect'
  }

  // 非微信/企业微信环境 → 拒绝访问
  document.body.innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:100vh;font-size:16px;color:#666;">请在微信或企业微信中打开此页面</div>'
  return 'redirect'
}
